import { Map } from 'immutable';
import { TOGGLE_SIDEBAR, SET_ACTIVE_TAB, TOGGLE_USER_MENU } from '../actions/sidebar';
import { OPEN_QUICKBET_MODAL, CLOSE_QUICKBET_MODAL } from '../actions/coupon/quickbet';
import { OPEN_BETSLIP_MODAL, CLOSE_BETSLIP_MODAL } from '../actions/coupon/coupon';
import { SUCCESS_FETCH_COMBOBET_TOKEN } from "../actions/combobet";
import { CHANGE_LOCALE } from '../actions/locale';
import { CLEAR_LIVE, CLEAR_LIVE_MATCH } from '../actions/live';
import { CHANGE_THEME } from '../actions/theme';
import entitiesReducer from './entities/entitiesReducer';
import menuReducer from './menu/menuReducer';
import linesMenuReducer from './menu/linesMenuReducer';
import profileReducer from './profile/profileReducer';
import displayModeReducer from './displayModeReducer';
import FavoriteAmountsReducer from './favouriteAmountsReducer';
import authReducer from './auth/authReducer';
import registrationReducer from './registration/registrationReducer';
import bettingHistoryReducer from './betting-history/bettingHistoryReducer';
import accountHistoryReducer from './account-history/accountHistoryReducer';
import unsettledBetsReducer from './unsettled-bets/unsettledBetsReducer';
import bonusReducer from './bonus/bonusReducer';
import popularLiveReducer from './popularLive';
import clientReducer from './clientReducer';
import bettingModeReducer from './bettingModeReducer';
import * as RepositoryState from '../constants/RepositoryState';
import * as DisplayMode from '../constants/DisplayMode';
import * as FavoriteAmounts from '../constants/FavoriteAmount';
import * as LineActions from '../actions/lines';
import newsReducer from './news/newsReducer';
import { CONFIG } from '../config';
if (localStorage.getItem('favorite_1') === null) {
    localStorage.setItem('favorite_1', FavoriteAmounts.FAVOURITE_1);
}
if (localStorage.getItem('favorite_2') === null) {
    localStorage.setItem('favorite_2', FavoriteAmounts.FAVOURITE_2);
}
if (localStorage.getItem('favorite_3') === null) {
    localStorage.setItem('favorite_3', FavoriteAmounts.FAVOURITE_3);
}
if (localStorage.getItem('favorite_4') === null) {
    localStorage.setItem('favorite_4', FavoriteAmounts.FAVOURITE_4);
}
var initialLive = Map({
    sports: Map(),
    leagues: Map(),
    matches: Map(),
    scores: Map(),
    outcomes: Map(),
    rates: Map(),
    valid: true,
    state: RepositoryState.NOT_INITED,
    version: 0,
    selectedMatchId: null
});
var initialState = Map({
    languageId: CONFIG.languageId,
    sidebarToggled: false,
    userMenuToggled: false,
    quickbetModalToggled: false,
    betSlipModalToggled: false,
    activeTab: 'live',
    live: initialLive,
    liveMatch: initialLive,
    timetable: new Map({
        sports: new Map(),
        leagues: new Map(),
        matches: new Map(),
        valid: true,
        state: RepositoryState.NOT_INITED
    }),
    results: Map({
        sports: Map(),
        leagues: Map(),
        matches: Map(),
        scores: Map()
    }),
    preMatch: Map({
        sports: Map(),
        leagues: Map(),
        matches: Map(),
        outcomes: Map(),
        rates: Map(),
        valid: true,
        fetching: false
    }),
    popularMatches: Map({
        sports: Map(),
        leagues: Map(),
        matches: Map(),
        outcomes: Map(),
        rates: Map(),
        valid: true,
        fetching: false
    }),
    menu: Map({
        sports: Map(),
        menuFetching: false
    }),
    linesMenu: Map({
        sports: Map(),
        menuFetching: false
    }),
    bets: {
        isLoading: false,
        data: []
    },
    bettingMode: {
        acceptIncrease: false,
        acceptDecrease: false,
        oneClickAmount: 50,
        isOneClickOn: false
    },
    bonus: {
        data: [],
        isSubscribing: undefined,
        subcriptionError: undefined
    },
    unsettledBets: {
        isLoading: false,
        detailsIsLoading: false,
        data: [],
        details: []
    },
    operations: Map({
        isLoading: false,
        data: undefined,
        error: false
    }),
    betHistory: new Map({
        loading: false
    }),
    displayMode: {
        type: DisplayMode.ALL
    },
    favoriteAmounts: new Map({
        favorite_1: +localStorage.getItem('favorite_1'),
        favorite_2: +localStorage.getItem('favorite_2'),
        favorite_3: +localStorage.getItem('favorite_3'),
        favorite_4: +localStorage.getItem('favorite_4'),
    }),
    news: {
        fetching: false,
        news: []
    },
    popularLive: [],
    client: {
        country: CONFIG.countryCode,
        ip: '127.0.0.1',
        fetched: false
    },
    darkTheme: true
});
export default (function (state, action) {
    if (state === void 0) { state = initialState; }
    // eslint-disable-next-line default-case
    switch (action.type) {
        case TOGGLE_SIDEBAR:
            state = state.update('sidebarToggled', function () { return !action.data; });
            break;
        case TOGGLE_USER_MENU:
            state = state.update('userMenuToggled', function () { return !action.data; });
            break;
        case SET_ACTIVE_TAB:
            state = state.update('activeTab', function () { return action.data; });
            break;
        case CLEAR_LIVE:
        case CLEAR_LIVE_MATCH:
            state = state.update('activeTab', function () { return 'live'; });
            break;
        case OPEN_BETSLIP_MODAL:
            state = state.update('betSlipModalToggled', function () { return true; });
            break;
        case CLOSE_BETSLIP_MODAL:
            state = state.update('betSlipModalToggled', function () { return false; });
            break;
        case OPEN_QUICKBET_MODAL:
            state = state.update('quickbetModalToggled', function () { return true; });
            break;
        case CLOSE_QUICKBET_MODAL:
            state = state.update('quickbetModalToggled', function () { return false; });
            break;
        case CHANGE_LOCALE:
            if (window.SIR) {
                window.SIR('changeLanguage', action.data === 1 ? 'ru' : 'en');
            }
            state = state.update('languageId', function () { return action.data; });
            localStorage.setItem('languageId', action.data);
            break;
        case LineActions.FETCH_LEAGUE_LINE_HEADERS:
            var initial_1 = Map({
                sports: Map(),
                leagues: Map(),
                matches: Map(),
                outcomes: Map(),
                rates: Map(),
                valid: true,
                fetching: false
            });
            state = state.update('preMatch', function () { return initial_1; });
            break;
        case SUCCESS_FETCH_COMBOBET_TOKEN:
            var win_1 = document.getElementById('combobetFrame').contentWindow;
            setTimeout(function () {
                win_1.postMessage({ token: action.data }, 'https://combo.fp.kz');
            }, 1000);
            state = state.update('tokenFetched', function () { return true; });
            break;
        case CHANGE_THEME:
            if (state.get('darkTheme')) {
                document.documentElement.classList.remove("dark");
            }
            else {
                document.documentElement.classList.add("dark");
            }
            localStorage.setItem('darkTheme', !state.get('darkTheme'));
            state = state.update('darkTheme', function () { return !state.get('darkTheme'); });
            break;
    }
    state = state.update('popularMatches', function (s) { return entitiesReducer(s, action, 'popularMatches'); });
    state = state.update('preMatch', function (s) { return entitiesReducer(s, action, 'preMatch'); });
    state = state.update('preMatchEvent', function (s) { return entitiesReducer(s, action, 'preMatchEvent'); });
    state = state.update('live', function (s) { return entitiesReducer(s, action, 'live'); });
    state = state.update('liveMatch', function (s) { return entitiesReducer(s, action, 'liveMatch'); });
    state = state.update('menu', function (e) { return entitiesReducer(e, action, 'menu'); });
    state = state.update('results', function (r) { return entitiesReducer(r, action, 'results'); });
    state = state.update('timetable', function (t) { return entitiesReducer(t, action, 'timetable'); });
    state = state.update('menu', function (e) { return menuReducer(e, action); });
    state = state.update('linesMenu', function (e) { return linesMenuReducer(e, action); });
    state = state.update('auth', function (c) { return authReducer(c, action); });
    state = state.update('registration', function (reg) { return registrationReducer(reg, action); });
    state = state.update('displayMode', function (dm) { return displayModeReducer(dm, action); });
    state = state.update('favoriteAmounts', function (fa) { return FavoriteAmountsReducer(fa, action); });
    state = state.update('profile', function (pr) { return profileReducer(pr, action); });
    state = state.update('bets', function (b) { return bettingHistoryReducer(b, action); });
    state = state.update('bettingMode', function (bm) { return bettingModeReducer(bm, action); });
    state = state.update('bonus', function (state) { return bonusReducer(state, action); });
    state = state.update('operations', function (b) { return accountHistoryReducer(b, action); });
    state = state.update('unsettledBets', function (b) { return unsettledBetsReducer(b, action); });
    state = state.update('news', function (n) { return newsReducer(n, action); });
    state = state.update('popularLive', function (n) { return popularLiveReducer(n, action); });
    state = state.update('client', function (c) { return clientReducer(c, action); });
    return state;
});



// WEBPACK FOOTER //
// ./src/reducers/applicationReducer.js